import _ from 'lodash';

import { createApiReducer } from 'src/api';

import {
  ADD_DBA_START,
  ADD_DBA_SUCCESS,
  ADD_DBA_FAILURE,
  UPDATE_DBA_START,
  UPDATE_DBA_SUCCESS,
  UPDATE_DBA_FAILURE,
  DELETE_DBA_START,
  DELETE_DBA_SUCCESS,
  DELETE_DBA_FAILURE,
} from './actions';

export const transformDBA = response => ({
  id: response.id,
  name: response.dba_name,
});

const updateItem = (list, key, value, newItem) => {
  return list.map(item => {
    if (item[key] === value) {
      return newItem;
    }
    return item;
  });
};

const accountAddDBAReducer = createApiReducer(
  [ADD_DBA_START, ADD_DBA_SUCCESS, ADD_DBA_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      dbas: [...state.data.dbas, transformDBA(payload)],
    };
  },
  error => transformDBA(_.get(error, 'payload.response', {}))
);

const accountDeleteDBAReducer = createApiReducer(
  [DELETE_DBA_START, DELETE_DBA_SUCCESS, DELETE_DBA_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      dbas: state.data.dbas.filter(d => d.id !== payload.id),
    };
  },
  error => transformDBA(_.get(error, 'payload.response', {}))
);

const updateDBA = (payload, state) => {
  const newDBA = transformDBA(payload);

  return {
    ...state.data,
    dbas: updateItem(state.data.dbas, 'id', newDBA.id, newDBA),
  };
};

const accountUpdateDBAReducer = createApiReducer(
  [UPDATE_DBA_START, UPDATE_DBA_SUCCESS, UPDATE_DBA_FAILURE],
  updateDBA,
  error => transformDBA(_.get(error, 'payload.response', {}))
);

export const reducers = [
  accountAddDBAReducer,
  accountUpdateDBAReducer,
  accountDeleteDBAReducer,
];
